
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 59.9 59.9"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#1bd3f2","fill-opacity":".3","stroke":"#1bd3f2","stroke-linecap":"square","stroke-width":"1.085","d":"M.8 30L29.9.7l29.2 29.1L30 59.1z","paint-order":"markers fill stroke"}}),_c('g',{attrs:{"fill":"#46e0fa"}},[_c('path',{attrs:{"d":"M30 33.7c-.5 0-.9.2-1.1.4-.3.2-.4.6-.4 1 0 .5.1.8.4 1 .2.3.6.4 1 .4.5 0 .8 0 1-.3.3-.3.5-.6.5-1 0-.5-.2-.9-.4-1.1-.3-.2-.6-.4-1-.4zm3.1-8.7c-.6-.6-1.5-.9-2.7-.9-1.3 0-2.6.4-3.9 1l1 1.8c1-.5 2-.8 2.7-.8.5 0 .9.1 1.1.3.3.2.4.5.4.8 0 .3 0 .6-.2.9-.2.3-.6.6-1.2 1s-1 .9-1.2 1.2c-.2.4-.3.9-.3 1.4v.6h2.1v-.5l.2-.8 1-.9c.8-.5 1.3-1 1.6-1.4.3-.5.4-1 .4-1.6 0-1-.3-1.6-1-2.2z"}}),_c('path',{attrs:{"d":"M30.3 17.7a12.6 12.6 0 100 25.2 12.6 12.6 0 000-25.2zm0 23.1a10.5 10.5 0 110-21 10.5 10.5 0 010 21z"}})])])
          )
        }
      }
    